import Pagination from './pagination'

export default {
  install (Vue) {
    Vue.component('Pagination', Pagination)
  }
}
